import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './agent-booking-mail-inprocess-ask-for-help.component.ajs.html';

const MODULE_NAME = 'agentBookingMailInprocessAskForHelp';

class AgentBookingMailInprocessAskForHelpCtrl implements IComponentController {
  public name = MODULE_NAME;

  responseId: string;

  $onInit() {}
}

export class AgentBookingMailInprocessAskForHelp implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  } as { [binding: string]: string };
  controller = [AgentBookingMailInprocessAskForHelpCtrl];
}

export default MODULE_NAME;
